export default "__VITE_ASSET__e8MxDq2K__"